import getRootState from './rootStateSelector';

export const getLounge = (state) => getRootState(state).get('lounge');
